<modal #modal>
  <div class="product-change-modal" #top>
    <button class="btn-close" aria-label="Luk" aria-roledescription="Luk modal" (click)="closeModal()">
      <img src="../../../../../assets/icons/close-b.svg" />
    </button>

    <h1>Ny gevinstplan <br> fra oktober 2024</h1>
    <div class="content">

        <p class="text-start">I oktober 2024 ændrer vi Klasselotteriets gevinstplan til nedenstående.</p>

        <h3>Gevinstplan fra oktober 2024</h3>
        <p>Antal lodder: 500.000</p>

        <div class="winnings-table">
            <span class="item winnings-table-first-row">Antal</span>
            <span class="item winnings-table-first-row even">Gevinster</span>
            <span class="item">1</span>
            <span class="item even">3.000.000 kr.</span>
            <span class="item">14</span>
            <span class="item even">1.180.000 kr.</span>
            <span class="item">15</span>
            <span class="item even">150.000 kr.</span>
            <span class="item">15</span>
            <span class="item even">50.000 kr.</span>
            <span class="item">15</span>
            <span class="item even">20.000 kr.</span>
            <span class="item">50</span>
            <span class="item even">10.000 kr.</span>
            <span class="item">50</span>
            <span class="item even">2.600 kr.</span>
            <span class="item">15.000</span>
            <span class="item even">1.200 kr.</span>
            <span class="item">9.000</span>
            <span class="item even">600 kr.</span>
            <span class="item total-small">Total</span>
            <span class="item even total-small clr-red">Total</span>
            <span class="item total">24.160</span>
            <span class="item even total">46.850.000 kr.</span>
        </div>

        <p class="mt-4 mb-0">Læs mere på</p>
        <p><a href="/2024" target="_blank">www.klasselotteriet.dk/2024</a></p>
    </div>
  </div>
</modal>